package com.milta.core.localization.translations.fr

import com.milta.core.localization.RouteCreationStrings

internal val RouteCreation = RouteCreationStrings(
    newRouteTitle = "Nouvelle tournée",
    stepDeliveries = "Livraisons",
    stepDrivers = "Chauffeurs",
    stepDistribution = "Répartition",
    deliveriesSummary = "%1 livraisons · %2 colis",
    deliveriesSummaryOne = "1 livraison · %1 colis",
    toFixCount = "%1 à corriger",
    allAddressesCorrect = "Toutes les adresses sont correctes",
    filterAll = "Toutes %1",
    filterToFix = "À corriger %1",
    fixAddressesToContinue = "Corrigez %1 adresses pour continuer",
    fixOneAddressToContinue = "Corrigez 1 adresse pour continuer",
    continueWithDeliveries = "Continuer · %1 livraisons",
    continueWithOneDelivery = "Continuer · 1 livraison",
    chooseAtLeastOneDriver = "Choisissez au moins un chauffeur",
    reasonMissingHouseNumber = "Numéro de rue manquant",
    reasonNotFound = "Adresse introuvable",
    reasonUnverified = "Vérification impossible, réessayez",
    missingHouseNumberExample = "Il manque le numéro de rue. Exemple : %1",
    notFoundHelp = "Adresse introuvable. Vérifiez la rue, le numéro et le code postal.",
    unverifiedHelp = "L'adresse n'a pas pu être vérifiée pour le moment. Réessayez dans quelques instants.",
    addToExistingHint = "Elles s'ajoutent aux %1 livraisons déjà dans la liste.",
    importFileAction = "Importer un fichier",
    importFileHint = "Excel (.xlsx, .xls), CSV ou PDF",
    manualEntryAction = "Saisie manuelle",
    manualEntryHint = "Nom, adresse, téléphone, heure limite",
    addDeliveryTitle = "Ajouter une livraison",
    deleteDelivery = "Supprimer la livraison",
    addedFileAnalysing = "Analyse de %1 en cours…",
    addedFileFailed = "L'import de %1 n'a pas abouti. Aucune livraison n'a été ajoutée.",
    errorAddressesToFix = "Certaines adresses n'ont pas été validées : corrigez-les dans la liste « À corriger ».",
    errorAddressesCheckRetry = "La vérification des adresses n'a pas abouti. Réessayez dans quelques instants.",
    errorBatchAlreadyDispatched = "Cette répartition a déjà été envoyée aux chauffeurs.",
    editDeliveryTitle = "Modifier la livraison",
    zoneLabel = "Zone %1",
    workloadBalanced = "Temps de travail équilibrés entre les chauffeurs",
    workloadGap = "Écart de temps de travail entre les chauffeurs : %1",
    importAddedFromScan = "%1 livraisons ajoutées depuis le scan",
    importAddedOneFromScan = "1 livraison ajoutée depuis le scan",
    importAddedFromPdf = "%1 livraisons ajoutées depuis le PDF",
    importAddedOneFromPdf = "1 livraison ajoutée depuis le PDF",
    importAddedFromSpreadsheet = "%1 livraisons ajoutées depuis le fichier Excel",
    importAddedOneFromSpreadsheet = "1 livraison ajoutée depuis le fichier Excel",
    importAddedToFixSuffix = ", dont %1 à corriger",
    deliverySearchOpenAction = "Rechercher une livraison",
    deliverySearchCount = "%1 sur %2",
    deliverySearchCountToFix = "%1 sur %2 à corriger",
    deliverySearchEmptyTitle = "Aucune livraison ne correspond",
    deliverySearchEmptyToFixHint = "Aucune livraison à corriger ne correspond. Essayez sous « Toutes ».",
)
